import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisableControlDirective } from "./disable-control.directive";
import { EmptyToNullDirective } from "./empty-to-null.directive";

@NgModule({
  declarations: [DisableControlDirective, EmptyToNullDirective],
  exports: [DisableControlDirective, EmptyToNullDirective],
  imports: [CommonModule],
})
export class DirectivesModule {}
